export const FPSR_CDN_ASSETS_BASE = 'https://fpsr.b-cdn.net/2.1.11';
export const FPSR_ASSET_VERSION = '2.1.11';
export const MAX_CONCURRENT_ASSET_DECODES = 2;

const CDN_TOKEN_KEYS = new Set(['expires', 'token', 'token_path']);

/**
 * Optional Bunny directory-token query for local/debug when Origin bypass
 * is unavailable. Set `VITE_FPSR_CDN_TOKEN_QUERY` (same format as fpsr viewer).
 */
export function cdnTokenFetch(): typeof fetch | undefined {
  const raw = import.meta.env.VITE_FPSR_CDN_TOKEN_QUERY?.trim().replace(
    /^\?/,
    ''
  );
  if (!raw) return undefined;

  const tokenQuery = new URLSearchParams(raw);
  const expectedPath = `/${FPSR_ASSET_VERSION}/`;
  const keys = [...tokenQuery.keys()];
  if (
    keys.some(key => !CDN_TOKEN_KEYS.has(key)) ||
    !tokenQuery.get('token')?.startsWith('HS256-') ||
    !/^\d+$/.test(tokenQuery.get('expires') ?? '') ||
    tokenQuery.get('token_path') !== expectedPath
  ) {
    console.warn(
      `Ignoring invalid VITE_FPSR_CDN_TOKEN_QUERY; expected an HS256 directory token for ${expectedPath}`
    );
    return undefined;
  }

  const cdnOrigin = new URL(FPSR_CDN_ASSETS_BASE).origin;
  return (input, init) => {
    const request = input instanceof Request ? input : undefined;
    const requestUrl =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : input.url;
    const url = new URL(requestUrl);
    if (
      url.origin === cdnOrigin &&
      url.pathname.startsWith(expectedPath)
    ) {
      tokenQuery.forEach((value, key) => url.searchParams.set(key, value));
    }
    if (request) return fetch(new Request(url, request), init);
    return fetch(url, init);
  };
}
